module.exports = __webpack_public_path__ + "static/media/register-sucess-left-image.c5c61794.svg";